// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const overlayMobileHeight = "100vh";
export const textCenter = "Overlay__textCenter__KGhNF";
export const overlay = "Overlay__overlay__mxgNQ";
export const overlayShrunkSidebar = "Overlay__overlayShrunkSidebar__gH9Mj";
export const isHeightSet = "Overlay__isHeightSet__KMWdg";
export const fixSafariIos = "Overlay__fixSafariIos__6HRD7";